/* eslint-disable */
import React, { PropTypes } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import RequiredMark from '../../../commonComponents/RequiredMark';
import { browserHistory } from 'react-router';
import DayPicker from '../../../commonComponents/DayPicker';
// import DatePicker from 'react-datepicker';
import moment from 'moment';
// import { Creatable } from 'react-select';
import Select from 'react-virtualized-select';
import { FileDropAreaCt } from '../../../commonComponents/FileDropAreaCt';
import { onFileDrop2, onFileDelete2 } from '../../../commonComponents/onFileModify';
import Tooltip from '../../../commonComponents/Tooltip';
import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
import RepairPdfContentPs from './RepairPdfContentPs';
import parentStateHandler from '../../../commonJS/parentStateHandler';
// import { numberHandler } from '../../../commonJS/addCommasToNumber';
// import removeCommasToNumber from '../../../commonJS/removeCommasToNumber';
import exportPDF from '../../../commonJS/exportPDF';
import { textInputOnChange } from '../../../commonJS/onFormChanges';
import PartsSearchAreaCt from '../../../commonComponents/PartsSearchAreaCt';
import Uploading from '../../../commonComponents/DataLoading';
import TextareaWithLink from '../../../commonComponents/TextareaWithLink';

// import {
// 	TextField, SelectField,
// 	DatePickerInstance, TextAreaField, ReadOnlyField
// } from './OnlineRepairPs';

import {
	Modal, Button, Col, Row, Well,
	FormGroup, ControlLabel, FormControl, HelpBlock, Tabs, Tab
} from 'react-bootstrap';


const Hr = props => <hr style={{ borderTop: '1px solid #ddd', ...props.style }} />;

const part_obj = {
	part_id: '',
	part_name: '',
	amount: 0,
	remark: '',
	is_double: false
}

// const TabBtn = (props) => {
// 	const { sm, title, ...otherProps } = props;
// 	return (
// 		<Col sm={props.sm}>
// 			<Button {...otherProps}
// 				style={{ width: '100%' }}>
// 				{props.title}
// 			</Button>
// 		</Col>
// 	);
// }

const DropDownMenu = props => {
	const { languageData, languageCode } = window.myConsts;

	return (
		<Col sm={props.sm}>
			<FormGroup validationState={props.validationState} style={{ position: 'relative' }}>
				<ControlLabel>{props.required ? <span style={{ color: 'red' }}>* </span> : ''}{props.label}
					{
						!props.disabled &&
							props.stateName === 'company' ?
							<img role='img' src='/imgs/ic_search_nor.svg' alt='' className='text-center'
								style={{ position: 'absolute', top: -5, right: 5, width: 25, height: 25, cursor: 'pointer' }} onClick={() => { props.showSearchCompanyContactModal() }} />
							: null
					}
				</ControlLabel>
				<div className={'validation-state-' + props.validationState}>
					<Select
						inputProps={{ id: props.id }}
						multi={props.multi}
						openOnFocus={true}
						disabled={props.stateName === 'company' ? true : props.disabled}
						value={props.value}
						valueKey={props.valueKey}
						labelKey={props.labelKey}
						matchProp='label'
						clearable={props.clearable || false}
						placeholder={
							props.stateName === 'company'
								? ''
								: !props.disabled
									? languageData['528'][languageCode]
									: ''
						}
						noResultsText={languageData['448'][languageCode]}
						onChange={selection => { props.onChange(selection, props.stateName); }}
						options={props.options}
						filterOptions={props.filterOptions} />
				</div>
			</FormGroup>
		</Col>
	)
};

const SearchSNResult = props => {
	const { languageData, languageCode } = window.myConsts;

	let
		cancelBtn = (
			<Button onClick={props.closeModal} className='funBtn' style={{ zIndex: 'unset' }}>
				{languageData['452'][languageCode]}
			</Button>
		),
		modeBtns = (
			<Button onClick={props.onSaveSN} className='funBtn'
				disabled={!props.selectSNValue} style={{ zIndex: 'unset' }}>
				{languageData['177'][languageCode]}
				{
					props.selectSNValue
						? ''
						: <Tooltip tipText={'尚有必填欄位未填寫'} />
				}
			</Button>
		);

	return (
		<Modal id='modal-product-spec' show={true} onHide={props.closeModal} bsSize='large'
			keyboard={false} backdrop='static'>
			<Modal.Header>
				<Modal.Title>
					<span className='textLineHeight' style={{ float: 'left' }}>{languageData['444'][languageCode]}</span>
					{cancelBtn}
					{modeBtns}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<FormGroup controlId='selectSN'>
					<ControlLabel><RequiredMark />{`${languageData['444'][languageCode]} (儀器序號 / 客戶全稱 / 聯絡人 / 儀器型號)`}</ControlLabel>
					<Select
						inputProps={{ id: 'selectSNForModal' }}
						openOnFocus={true}
						clearable={false}
						disabled={false}
						valueKey='tag'
						labelKey='name'
						matchProp='label'
						value={props.selectSNValue}
						options={props.serialNumberList}
						onChange={option => props.onSNModalChange(option)}
						placeholder={languageData['528'][languageCode]}
						filterOptions={props.filterOptions}
					/>
				</FormGroup>
			</Modal.Body>
			<Modal.Footer>
				{cancelBtn}
			</Modal.Footer>
		</Modal>
	)
};

const SearchCompanyContactResult = props => {
	const { languageData, languageCode } = window.myConsts;

	let
		{
			activeTabKeySearch,
			searchDataCompany, searchDataContact,
			searchDataValue, searchDataList
		} = props.state,
		disabled = !activeTabKeySearch || !searchDataValue,
		cancelBtn = (
			<Button onClick={props.closeModal} className='funBtn' style={{ zIndex: 'unset' }}>
				{languageData['452'][languageCode]}
			</Button>
		),
		modeBtns = (
			<Button onClick={() => { props.onSave(999) }} className='funBtn'
				disabled={disabled} style={{ zIndex: 'unset' }}>
				{languageData['177'][languageCode]}
				{
					disabled ?
						<Tooltip
							placement='left'
							tipText={'請選擇其中一項搜尋功能'}
						/>
						: null
				}
			</Button>
		);

	return (
		<Modal id='modal-product-spec' show={true} onHide={props.closeModal} bsSize='large'
			keyboard={false} backdrop='static'>
			<Modal.Header>
				<Modal.Title>
					<span className='textLineHeight' style={{ float: 'left' }}>{'客戶全稱/聯絡人員查詢'}</span>
					{cancelBtn}
					{modeBtns}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Tabs activeKey={activeTabKeySearch} id='div-repair-tabs-containers'
					onSelect={() => { props.onTabClickSearch(activeTabKeySearch) }} >
					<Tab eventKey={1} title={'客戶全稱'}>
						<Row>
							<Col sm={11}>
								<input
									style={{ margin: '10px 0 20px' }}
									className='form-control'
									value={searchDataCompany}
									onChange={(event) => { props.setSearchData('searchDataCompany', event.target.value) }} />
							</Col>
							<Col sm={1} style={{ paddingLeft: 0 }}>
								<Button
									style={{
										margin: '10px 0px 20px',
										width: '100%'
									}}
									disabled={!searchDataCompany}
									onClick={(e) => { props.onSearch(activeTabKeySearch, searchDataCompany) }}>
									{languageData['78'][languageCode]}
									{
										!searchDataCompany ?
											<Tooltip
												placement='left'
												tipText={'請輸入客戶全稱關鍵字'}
											/>
											: null
									}
								</Button>
							</Col>
						</Row>
					</Tab>
					<Tab eventKey={2} title={'聯絡人'}>
						<Row>
							<Col sm={11}>
								<input
									style={{ margin: '10px 0 20px' }}
									className='form-control'
									value={searchDataContact}
									onChange={(event) => { props.setSearchData('searchDataContact', event.target.value) }} />
							</Col>
							<Col sm={1} style={{ paddingLeft: 0 }}>
								<Button
									style={{
										margin: '10px 0px 20px',
										width: '100%'
									}}
									disabled={!searchDataContact}
									onClick={(e) => { props.onSearch(activeTabKeySearch, searchDataContact) }}>
									{languageData['78'][languageCode]}
									{
										!searchDataContact ?
											<Tooltip
												placement='left'
												tipText={'請輸入聯絡人員關鍵字'}
											/>
											: null
									}
								</Button>
							</Col>
						</Row>
					</Tab>
				</Tabs>
				{
					searchDataList.length > 0 ?
						<div>
							<Hr style={{ margin: 0 }} />
							<Select
								inputProps={{ id: 'companyContactList' }}
								openOnFocus={true}
								clearable={true}
								disabled={false}
								valueKey='id'
								labelKey='name'
								matchProp='label'
								value={searchDataValue ? searchDataValue.id : ''}
								options={searchDataList}
								onChange={(option) => props.onChangeSelectValue(3, option)}
								placeholder={languageData['528'][languageCode]}
								filterOptions={props.filterOptions}
								style={{ margin: '15px 0' }}
							/>
						</div>
						: null
				}
			</Modal.Body>
			<Modal.Footer>
				{cancelBtn}
			</Modal.Footer>
		</Modal>
	)
};


export default class OnlineRepairServiceCt extends React.Component {

	constructor(props) {
		let d = new Date()
		super(props);
		this.handlers = {
			textInputOnChange: e => {
				textInputOnChange(e, this);
			},
			onChange: (selection, stateName, cb) => {
				const value = selection.value;

				let arr = [], arrName = [], len;

				switch (stateName) {
					case 'repair_department':
						len = selection.length;

						for (let i = 0; i < len; i++) {
							arr.push(selection[i].id);
							arrName.push(selection[i].name);
						}

						this.setState({ [stateName]: arr, repair_department_name: arrName.join() });
						break;
					case 'assign':
						len = selection.length;

						for (let i = 0; i < len; i++) {
							arr.push(selection[i].user_id);
						}

						this.setState({ [stateName]: arr });
						break;
					case 'collaborator':
						len = selection.length;

						for (let i = 0; i < len; i++) {
							arr.push(selection[i].id);
						}

						this.setState({ [stateName]: arr });
						break;
					// case 'service_type':
					// 	len = selection.length;

					// 	for (let i = 0; i < len; i++) {
					// 		arr.push(selection[i].service_type_id);
					// 	}

					// 	this.setState({ [id]: arr });
					// 	break;

					default:
						this.setState({ [stateName]: value });
						break;
				}
			},
			onSearchSNResultClick: (isSave) => {
				if (isSave) {
					const { company_data } = this.props,
						{ selectSN } = this.state,
						option = _.find(company_data, { id: selectSN.company_id });

					this.onChangeCompany(option);
					// this.loadContactData(selectSN.company_id);
					if (selectSN.contact_id === '0') {
						this.setState({
							// company: { id: selectSN.company_id, name: selectSN.company_name },
							serial_number: selectSN.serial_number,
							brand: selectSN.brand_name,
							product_line: selectSN.product_line,
							model_name: selectSN.machine_name,
							machine_model: selectSN.machine_model,
							customer_id: selectSN.customer_id,
							company_owner: selectSN.president
						})
					} else {
						this.setState({
							// company: { id: selectSN.company_id, name: selectSN.company_name },
							contact: { id: selectSN.contact_id, name: selectSN.contact_name },
							serial_number: selectSN.serial_number,
							brand: selectSN.brand_name,
							product_line: selectSN.product_line,
							model_name: selectSN.machine_name,
							machine_model: selectSN.machine_model,
							customer_id: selectSN.customer_id,
							company_owner: selectSN.president
						})
					}
				}

				this.setState({ selectSNValue: '', showSearchSNResult: false });
			},
			onSNModalChange: (option) => {
				const
					optTag = option === null || option.length === 0
						? ''
						: option.tag,
					optSN = option === null || option.length === 0
						? ''
						: option;

				this.setState({ selectSNValue: optTag, selectSN: optSN });
			},
			onSNLoadCompanyData: () => {
				const { company_data } = this.props,
					SN = $.trim(this.state.serial_number);

				if (SN) {
					this.setState({ is_loaded: false });

					$.ajax({
						type: 'get',
						url: `/api/M_Instrument_Data_Get.php?serial_number=${SN}`,
						success: res => {
							this.setState({ is_loaded: true });

							if (
								res.status === '0' &&
								res.result.length > 0
							) {
								const data = res.result;

								if (data.length === 1) {
									// 結果只有1筆，直接把結果放進欄位
									const option = _.find(company_data, { id: data[0].company_id });
									this.onChangeCompany(option);

									if (data[0].contact_id === '0') {
										this.setState({
											// company: { id: data[0].company_id, name: data[0].company_name },
											serialNumberList: data,
											serial_number: data[0].machine_number,
											brand: data[0].brand_name,
											product_line: data[0].product_line,
											model_name: data[0].machine_name,
											machine_model: data[0].machine_model,
											customer_id: data[0].customer_id,
											company_owner: data[0].president
										});
									} else {
										this.setState({
											// company: { id: data[0].company_id, name: data[0].company_name },
											contact: { id: data[0].contact_id, name: data[0].contact_name },
											serialNumberList: data,
											serial_number: data[0].machine_number,
											brand: data[0].brand_name,
											product_line: data[0].product_line,
											model_name: data[0].machine_name,
											machine_model: data[0].machine_model,
											customer_id: data[0].customer_id,
											company_owner: data[0].president
										});
									}
								} else if (data.length > 1) {
									// 結果有N筆，要出現選擇畫面
									let serialNumberList = [];
									for (let idx = 0; idx < data.length; idx++) {
										serialNumberList.push({
											company_id: data[idx].company_id,
											company_name: data[idx].customer_name,
											contact_id: data[idx].contact_id,
											contact_name: data[idx].contact_name,
											serial_number: data[idx].machine_number,
											brand: data[idx].brand_name,
											product_line: data[idx].product_line,
											model_name: data[idx].model_name,
											machine_model: data[idx].machine_model,
											customer_id: data[idx].customer_id,
											company_owner: data[idx].president,
											name: `${data[idx].machine_number} / ${data[idx].customer_name} / ${data[idx].contact_name} / ${data[idx].machine_model}`,
											tag: `${data[idx].id} / ${data[idx].machine_number} / ${data[idx].company_id} / ${data[idx].customer_name} / ${data[idx].contact_id} / ${data[idx].contact_name} / ${data[idx].machine_model}`,
											dataSource: data[idx]
										});
									}

									this.setState({
										serialNumberList,
										showSearchSNResult: true
									}, () => {
										$('#selectSNForModal').focus();
									});
								}
							} else { alert('查無資料'); }
						}
					});
				}
			},
			onShowSearchCompanyContactModal: (type) => {
				if (type === 1) {
					this.setState({
						activeTabKeySearch: 1,
						searchDataValue: '',
						searchDataList: [],
						showSearchCompanyContactModal: true
					})
				} else {
					this.setState({
						searchDataCompany: '',
						searchDataContact: '',
						showSearchCompanyContactModal: false
					})
				}
			},
			onSearchCompanyData: (type, data_) => {
				const data = $.trim(data_);

				let searchDataList = [];
				switch (type) {
					case 1:
						$.ajax({
							type: 'GET',
							url: `/api/M_Companys_ByName_Get.php?company_name=${data}`,
							complete: xhr => {
								const data = xhr.responseJSON;

								if (data.status === '0') {
									searchDataList =
										data.result.map((x, y) => {
											return {
												id: `${x.company_id}/${x.contact_id}`,
												name: `${x.customer_id}　${x.company_name}　${x.contact_name}`,
												address: x.address,
												...x
											}
										});
								} else alert('查無資料');

								this.setState({
									searchDataList,
									searchDataValue: ''
								}, () => {
									$('#companyContactList').focus();
								});
							}
						});
						break;
					case 2:
						$.ajax({
							type: 'GET',
							url: `/api/M_Contacts_ByName_Get.php?contact_name=${data}`,
							complete: xhr => {
								const data = xhr.responseJSON;

								if (data.status === '0') {
									searchDataList =
										data.result.map((x, y) => {
											return {
												id: `${x.company_id}/${x.contact_id}`,
												name: `${x.customer_id}　${x.company_name}　${x.contact_name}`,
												address: x.address,
												...x
											}
										});
								} else alert('查無資料');

								this.setState({
									searchDataList,
									searchDataValue: ''
								}, () => {
									$('#companyContactList').focus();
								});
							}
						});
						break;
					case 3:
						this.setState({ searchDataValue: data_ ? data_ : '' })
						break;
					case 999:
						const { activeTabKeySearch, searchDataValue } = this.state,
							item_ = [searchDataValue],
							item =
								item_.map((x, y) => {
									return {
										id: x.company_id,
										name: x.company_name,
										address: x.address,
										cell_phone: x.cell_phone,
										company_id: x.company_id,
										company_name: x.company_name,
										company_sname: x.company_sname,
										contact_address: x.contact_address,
										contact_id: x.contact_id,
										contact_name: x.contact_name,
										contact_work_phone: x.contact_work_phone,
										customer_id: x.customer_id,
										repair_department_name: x.department_name,
										disable_date: x.disable_date,
										email: x.email,
										president: x.president,
										tax_number: x.tax_number,
										telephone: x.telephone
									}
								});

						if (item.length > 0) {
							const thisItem = item[0];

							this.setState({
								customer_id: thisItem.customer_id,
								company_owner: thisItem.president
							}, () => {
								this.onChangeCompany(thisItem);
							})
						}
						this.handlers.onShowSearchCompanyContactModal(0);
						break;

					default:
				}
			}
		}

		// exporting pdf ===
		this.onExportPdfWithPhotoClick = (mode, batchStock, givenName, resolve) => {
			this.exportPhoto = true;
			this.setState({ showPdfContent: true }, () => { this.exportPdf(mode, batchStock, givenName, resolve) });
		}

		this.onExportPdfWithoutPhotoClick = (mode, batchStock, givenName, resolve) => {
			this.exportPhoto = false;
			this.setState({ showPdfContent: true }, () => { this.exportPdf(mode, batchStock, givenName, resolve) });
		}

		this.pdfContentCreater = () => {
			const state = this.state,
				pages = [],
				parts = _.filter(state.parts, function (o) { return o.itemFlag !== 'delete' }),
				partLen = parts.length,
				loginCompanyInfo = {
					companyTitle: sessionStorage.companyTitle,
					companyLogo: sessionStorage.companyLogo,
					companyTel: sessionStorage.companyTel,
					companyFax: sessionStorage.companyFax,
					companyAddress: sessionStorage.companyAddress,
					companyEmail: sessionStorage.companyEmail
				},
				data = {
					loginCompanyInfo,
					statusName: _.find(this.props.status_data, { status_id: this.state.status }).status_name,
					// * 1 以正確判斷文字'0'的情況
					// formTypeName: this.state.form_type * 1 ? _.find(this.props.form_type_data, { type_id: this.state.form_type }).type_name : '',
					// areaTypeName: this.state.area * 1 ? _.find(this.props.area_data, { area_type_id: this.state.area }).area_type_name : '',
					contractName: this.state.maintain_contract * 1 ? _.find(this.state.contact_data, { warranty_type_id: this.state.maintain_contract }).warranty_type_name : '',
					factoryName: this.state.factory * 1 ? _.find(this.props.factory_data, { factory_id: this.state.factory, company_id: this.state.company.id }).factory_name : '',
					// judgeName: this.state.responsibility * 1 ? _.find(this.props.responsibility_data, { judge_id: this.state.responsibility }).judge_name : '',
					satisfactionName: this.state.service_result * 1 ? _.find(this.props.service_result_data, { satisfaction_id: this.state.service_result }).satisfaction_name : '',
					// currencyName: this.state.currency * 1 ? _.find(this.props.currency_data, { currency_id: this.state.currency }).currency_name : '',
					...this.state
				};

			// id陣列轉名稱字串函式
			function convertToNameStr(objToExtend, extendKeyName, stateName, dataProps, keyToFind, nameKey) {
				// 有選擇時才處理
				objToExtend[extendKeyName] = (state[stateName] && state[stateName] !== '0') ? (function (self) {
					// id轉array
					const idArr = state[stateName].split(','),
						nameArr = [],
						len = idArr.length

					for (let i = 0; i < len; i++) {
						nameArr.push(_.find(self.props[dataProps], { [keyToFind]: idArr[i] })[nameKey]);
					}
					// 使用'、'分隔將array轉成字串
					return nameArr.join('、');
				}(this)) : '';
			}

			// 綁定this與第一個參數
			convertToNameStr = convertToNameStr.bind(this, data);

			// convertToNameStr(
			// 	'assignedMenNames',
			// 	'assign', 'assign_data', 'user_id', 'user_name'
			// );
			// 名稱字串轉 array 再用指定分隔符號轉字串
			data['assignedMenNames'] = state.assignedMenNames.split(',').join('、');

			convertToNameStr(
				'serviceTypeNames',
				'service_type', 'service_type_data', 'service_type_id', 'service_type_name'
			);

			// convertToNameStr(
			// 	'issueTypeNames',
			// 	'question_category', 'question_data', 'issue_type_id', 'issue_type_name'
			// );

			// main page
			pages.push(<RepairPdfContentPs key={pages.length} pdfType='main' data={data} />);

			// part pages
			if (partLen > 5) {
				// 超過5筆才會有清單頁，每頁最多23筆
				const partListPages = Math.ceil(partLen / 23);

				for (let i = 0; i < partListPages; i++) {
					const startInd = i * 23,
						// 超過最後1筆時取最後1筆的索引
						endInd = Math.min(startInd + 22, (partLen - 1)),
						// + 1原因為slice不含尾端
						filteredPartsList = parts.slice(startInd, endInd + 1);

					pages.push(<RepairPdfContentPs key={pages.length} startInd={startInd} pdfType='partList' filteredPartsList={filteredPartsList} data={data} />);
				}

			}

			// photo pages
			if (this.exportPhoto) {
				// qmo不知為何未把repair_downloadedFiles與maintain_downloadedFiles列在state初始
				// 為免預期之外的影響，不去改動它，改成使用前判斷屬性是否存在

				// 過濾圖片檔案
				const issuePhotos = [], repairPhotos = [];

				if (state.repair_downloadedFiles) {
					state.repair_downloadedFiles.forEach((item, ind) => {
						if (item.type.indexOf('image') !== -1) issuePhotos.push(item);
					});
				}

				if (state.maintain_downloadedFiles) {
					state.maintain_downloadedFiles.forEach((item, ind) => {
						if (item.type.indexOf('image') !== -1) repairPhotos.push(item);
					})
				}

				const issuePhotoLen = issuePhotos.length,
					repairPhotoLen = repairPhotos.length,
					// 除以4進位得到半頁數，兩半頁成1頁
					issuePhotoPages = Math.floor(Math.ceil(issuePhotoLen / 4) / 2);

				// 記錄不成整頁的issue photo起始索引與結束索引
				// initial為-1, -2做為是否有剩餘不成整頁判斷
				let issueRemainPhotoStartInd = 0, issueRemainPhotoEndInd = issuePhotoLen - 1;


				// 處理成整頁的issue photos
				for (let i = 0; i < issuePhotoPages; i++) {
					const startInd = i * 8,
						// 超過最後1筆時取最後1筆的索引
						endInd = Math.min(startInd + 7, (issuePhotoLen - 1)),
						// + 1原因為slice不含尾端
						issueFilteredPhotos = issuePhotos.slice(startInd, endInd + 1);

					pages.push(<RepairPdfContentPs key={pages.length} pdfType='photo' issueFilteredPhotos={issueFilteredPhotos} data={data} />);

					// 記錄成整頁的最後一筆索引做為餘下不成整頁的起始索引
					if (i === (issuePhotoPages - 1)) {
						// 有剩餘的情況
						if (issuePhotoLen > (endInd + 1)) {
							issueRemainPhotoStartInd = endInd + 1;
							issueRemainPhotoEndInd = issuePhotoLen - 1;
							// 無剩餘的情況
						} else {
							issueRemainPhotoStartInd = 0;
							issueRemainPhotoEndInd = - 1;
						}
					}
				}

				// 處理不成整頁的issue photos與maintain photos
				// issue photo有剩餘就一定只有半頁
				let issueRemainingPhotos;
				if ((issueRemainPhotoEndInd - issueRemainPhotoStartInd) >= 0) {
					issueRemainingPhotos = issuePhotos.slice(issueRemainPhotoStartInd, issueRemainPhotoEndInd + 1);
				}

				const repairPhotoPageUnits = Math.ceil(repairPhotoLen / 4) + (issueRemainingPhotos ? 1 : 0),
					repairPhotoPages = Math.ceil(repairPhotoPageUnits / 2);

				for (let i = 0; i < repairPhotoPages; i++) {
					// issue photo有剩餘時，repair photo位置需平移
					const startInd = (i * 8) - ((issueRemainingPhotos && i > 0) ? 4 : 0),
						// 超過最後1筆時取最後1筆的索引
						endInd = Math.min(startInd + 7 - ((issueRemainingPhotos && i === 0) ? 4 : 0), (repairPhotoLen - 1)),
						// + 1原因為slice不含尾端
						repairFilteredPhotos = repairPhotoLen ? repairPhotos.slice(startInd, endInd + 1) : [];

					if (issueRemainingPhotos && i === 0) {
						pages.push(<RepairPdfContentPs key={pages.length} pdfType='photo' issueRemainingPhotos={issueRemainingPhotos} repairFilteredPhotos={repairFilteredPhotos} data={data} />);
					} else {
						pages.push(<RepairPdfContentPs key={pages.length} pdfType='photo' repairFilteredPhotos={repairFilteredPhotos} data={data} />);
					}

				}

			}

			return pages;
		}

		this.exportPdf = (mode, batchStock, givenName, resolve) => {
			const jqEleContainers = $('.pdf-content-container'),
				fileName = givenName || `repair_${this.state.repair_id}`;

			exportPDF(jqEleContainers, fileName, () => {
				this.setState({ showPdfContent: false }, resolve);
			}, mode, batchStock);

		};

		// 是否輸出圖片依據
		this.exportPhoto = true;

		this.onTabClick = activeTabKey => {
			this.setState({ activeTabKey });
		};

		this.onTabClickSearch = activeTabKeySearch => {
			this.setState({ activeTabKeySearch: activeTabKeySearch === 1 ? 2 : 1 });
		};

		// ===
		this.state = {
			searchDataList: [],
			searchDataValue: '',
			searchDataCompany: '',
			searchDataContact: '',
			showSearchCompanyContactModal: false,
			showPartsSearchArea: false,
			serial_number_tmp: '',
			repair_department: [],
			repair_department_name: '',
			repair_priority: '',
			request_date: moment(),
			leave_time: null,
			brand: '',
			product_line: '',
			model_name: '',
			machine_model: '',
			customer_id: '',
			company_owner: '',
			location: '',
			expect_date: null,
			repair_hours: '',
			start_date: null,
			problem: '',
			repair_result: '',
			satisfactionId: '0',
			part_description: '',
			decision_description: '',
			cost_description: '',
			order_number: '',
			car_cost: '',
			prevent_description: '',
			qa_description: '',
			gm_description: '',
			parts_total: 0,
			tax_total: 0,
			create_user: '',
			create_id: '',
			activeTabKey: 1,
			activeTabKeySearch: 1,
			corp_vat_number: '',
			showPdfContent: false,
			canEdit: false,
			job_number: '',
			discount: 0,
			supervisor_review: '',
			enableEdit: false,
			is_error: false,
			is_loaded: false,
			status: '0',			//狀態
			form_type: '',		//表單類型
			repair_date: null,
			// repair_h: d.getHours(),			//時
			// repair_m: d.getMinutes(),			//分
			area: '0',					//地區/機型
			maintain_contract: '0',			//保固/維護合約
			company: null,			//公司
			factory: '0',			//廠區
			address: '',			//地址
			contact: null,		//聯絡人
			// contact_name: '',			//聯絡人姓名
			contact_phone: '',		//聯絡電話
			contact_mobile: '',		//行動電話
			contact_email: '',		//Email
			product_source: '',		//產品來源
			repair_man_id: this.props.user_id, //報修人員ID
			repair_man_name: this.props.user_name, //報修人員姓名
			product_model: null,		//產品
			// product_model_name: '',		//產品名稱
			serial_number: '',		//產品序號
			// description: '',			//說明
			service_type: '',			//服務類別
			service_track: '',			//對策成果
			assign: [],						//指派人員
			assignedMenNames: '',  		//指派人員姓名
			collaborator: [],				//協同人員
			assign_date: null,			//指派時間 api端變數是repair_date
			assign_h: '00',					//時
			assign_m: '00',					//分
			departure_date: null, 	//出發時間
			departure_h: '00',			//時
			departure_m: '00',			//分
			arrive_date: null,			//到達時間
			arrive_h: '00',					//時
			arrive_m: '00',					//分
			leave_date: null,				//離開時間
			leave_h: '00',					//時
			leave_m: '00',					//分
			question_category: '',		//問題分類
			responsibility: '',				//責任歸屬
			repair_content: '',				//報修內容
			repair_content_files: [],				//報修內容附件
			repair_preview: {
				previewsImg: [],
				previewsWORD: [],
				previewsEXCEL: [],
				previewsPOWERPOINT: [],
				previewsPDF: [],
				previewsVideo: []
			},
			delete_repair_files: [],
			maintain_content: '',						//維修內容
			maintain_content_files: [],			//維修內容附件
			maintain_preview: {
				previewsImg: [],
				previewsWORD: [],
				previewsEXCEL: [],
				previewsPOWERPOINT: [],
				previewsPDF: [],
				previewsVideo: []
			},
			delete_maintain_files: [],
			// parts: [Object.assign({}, part_obj)],	//零件資訊
			parts: [],	//零件資訊
			cost_type: '',
			message: '',
			working_cost: 0,			//工時費用
			service_cost: 0,			//服務基本(技術)費
			subtotal: 0, 				//合計
			tax: 0,							//稅
			total_amount: 0,			//總計
			currency: '',					//幣別
			receipt_number: '',		//發票編號
			receipt_title: '',		//發票抬頭
			sign: '',							//簽名
			signature_images: [],
			signatureapprover_images: [],
			signaturemanager_images: [],
			remarks: '',					//備註
			service_result: '',		//服務結果確認
			repair_id: '',
			contact_data: [],
			is_parts_data_loaded_for_state: false,
			factory_data: [],
			btnSaveDisable: true,
			showSearchSNResult: false,
			selectSN: '',
			selectSNValue: ''
		}

		this.onChangeContact = this.onChangeContact.bind(this);
		// this.onChangePartNumber = this.onChangePartNumber.bind(this);
		// this.onChangePartName = this.onChangePartName.bind(this);
		this.uploadFiles = this.uploadFiles.bind(this);
		this.deleteFiles = this.deleteFiles.bind(this);

		this.doSaveAJAX = formData => {
			const { route, closeModal } = this.props;

			let mode;
			// 編輯情境
			if ((this.props.params && this.props.params.id) || this.props.selectedItemId) {
				mode = 'edit';
				// 新增情境
			} else {
				mode = 'add';
			}

			$.ajax({
				type: 'post',
				url: `/api/M_ServiceSky_RepairSky_${mode === 'add' ? 'Post' : 'Update'}.php`,
				data: formData,
				processData: false,
				contentType: false,
				success: res => {
					if (res.status === '0') {
						this.setState({ is_error: false, enableEdit: false })
						this.uploadFiles('RepairIssue', res.result.id)
						this.uploadFiles('RepairSolution', res.result.id)
						this.setState({ repair_content_files: [], maintain_content_files: [] })
						this.props.reload(mode);

						// if ( route.type === 'add' ) {

						//  this.props.closeModal();
						// }
						// else if ( route.type === 'edit' ) {
						if (mode === 'edit') {
							this.deleteFiles('RepairIssue', res.result.id)
							this.deleteFiles('RepairSolution', res.result.id)
							this.setState({ delete_repair_files: [], delete_maintain_files: [] })
						}

						closeModal();
					} else { alert(res.msg) }
				},
				error: error => { }
			});
		};

		this.togglePartsSearchArea = () => {
			this.setState({ showPartsSearchArea: !this.state.showPartsSearchArea });
		};

		this.onAddToParts = (selectedPart) => {
			if (this.state.activeTabKey === 1) {
				const newArr = this.state.parts.slice();

				newArr.push({
					part_id: selectedPart.product_id,
					part_name: selectedPart.spec || '',
					amount: 1,
					remark: '',
					is_double: false
				});

				this.setState({ parts: newArr });
			} else {
				const newArr_ = this.state.parts.slice();

				$.ajax({
					type: 'GET',
					url: `/api/M_Lading_Data_Get.php?customer_id=${selectedPart.customer_id}`,
					complete: xhr => {
						const data = xhr.responseJSON;

						switch (data.status) {
							case '0':
								if (data.result.length > 0) {
									const filterData = _.filter(data.result, { doc_id: selectedPart.doc_id });

									_.forEach(filterData, (val, key) => {
										const product = val.product;

										_.forEach(product, (val1, key1) => {
											newArr_.push({
												part_id: val1.product_id,
												part_name: val1.spec_ename || '',
												amount: val1.quantity,
												remark: '',
												is_double: false
											});
										});
									});
								}
								break;

							default:
						}

						this.setState({ parts: newArr_ });
					}
				});
			}
		};

		this.parentStateHandler = ({ states, newValues }) => {
			parentStateHandler({ states, newValues, parentThis: this });
		};

		// file crud相關 ===========
		// for file upload，不需渲染的資料不使用state，避免多餘的render check
		// this.uploadedFiles = [];

		// for downloaded files that uploaded before
		this.onFileDrop = (downloadedFiles, previews) => {
			onFileDrop2(downloadedFiles, '', this, true, '', previews);
		};

		this.onFileDelete = (type, fileName, previews) => {
			onFileDelete2(type, fileName, this, true, previews);
		};

		// 配合api
		this.fileFilter = (orinFiles) => {
			// 檔案預處理
			let name = '', dotInd = '', type = '';

			const downloadedFiles = orinFiles.map((item, ind) => {
				name = item.file_name;
				dotInd = name.lastIndexOf('.');
				type = name.slice(dotInd + 1);

				let name_split = name.split('/'),
					name_split2 = name_split[(name_split.length - 1)].split('.'),
					file_id = name_split2[0];

				item.file_id = file_id

				switch (type) {
					case 'jpg':
						item.type = 'image/jpeg';
						break;
					case 'png':
						item.type = 'image/png';
						break;
					case 'svg':
						item.type = 'image/svg+xml';
						break;
					case 'pdf':
						item.type = 'application/pdf';
						break;
					case 'csv':
					case 'xls':
						item.type = '';
						// item.type = 'application/vnd.ms-excel';
						break;
					case 'xlsx':
						item.type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
						break;
					case 'ppt':
						item.type = 'application/vnd.ms-powerpoint';
						break;
					case 'pptx':
						item.type = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
						break;
					case 'doc':
						item.type = 'application/msword';
						break;
					case 'docx':
						item.type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
						break;
					case 'mp4':
						item.type = 'video/mp4';
						break;
						
					default:
				}

				return item;
			});

			return downloadedFiles;
		};
	}

	componentDidMount() {
		const { route, params, company_data } = this.props;

		let mode;
		// 編輯情境
		if ((this.props.params && this.props.params.id) || this.props.selectedItemId) {
			mode = 'edit';
			// 新增情境
		} else {
			mode = 'add';
		}

		switch (mode) {
			case 'add':
				this.setState({
					enableEdit: true,
					is_loaded: true
					// parts: [Object.assign({}, part_obj)]
				});

				// 客戶資訊tab情況下，預設指定公司
				if (!this.props.params) {
					const option = _.find(company_data, { id: this.props.company_id });
					this.onChangeCompany(option);
				}
				break;

			default:
				if (
					(
						params &&
						(
							params.id === 'pdf-export-withoutphoto' ||
							params.id === 'pdf-export'
						)
					) ||
					// 客戶資訊tab底下的情況
					this.props.selectedItemId.indexOf('pdfBacthExport') !== -1
				) {
					// 在匯出pdf時重整page情境處理
					if (!this.props.arrCheckedId.length) this.props.closeModal()

					// 開始批次匯出pdf
					// 依勾選id清單逐筆抓資料、建立html、截圖
					// 同時存在的html只有1份，全部截圖完成後，產生pdf
					// 流程用點擊下一筆的方式逐一處理
					const batchStock = [],
						arrCheckedId = this.props.arrCheckedId.slice(),
						len = arrCheckedId.length;

					// 定義遞迴函式
					const batchExportPDF = (batchStock, i, withPhoto) => {
						this.loadData(arrCheckedId[i], () => {
							// 三個參數依序為mode, batchStock, givenName
							// 前兩者一體，有就都要給
							// 此筆是否已是最後一筆，+1之後等於len代表此為最後一筆
							const isLast = ++i === len;

							let pm;

							if (withPhoto) {
								pm = new Promise((reso, rej) => { this.onExportPdfWithPhotoClick(isLast ? 'doBatchExport' : 'batching', batchStock, isLast ? 'pdfbundle' : null, reso) });
							} else {
								pm = new Promise((reso, rej) => { this.onExportPdfWithoutPhotoClick(isLast ? 'doBatchExport' : 'batching', batchStock, isLast ? 'pdfbundle' : null, reso) });
							}

							// 確保順序
							pm.then((value) => {
								// +1之後如果小於len則繼續，否則結束
								if (isLast) {
									// 結束匯出中…狀態，並清除勾選
									const arrIsCheck = this.props.arrIsCheck.map(() => false);
									this.props.parentStateHandler({ states: ['onExportPDF', 'arrCheckedId', 'arrIsCheck'], newValues: [false, [], arrIsCheck] });

									this.props.closeModal();
									return;
								}
								// 遞迴，++i時i已+1
								batchExportPDF(batchStock, i, withPhoto);
							}).catch((error) => {
								// 以下預防有錯誤時ui卡住
								// 結束匯出中…狀態，並清除勾選
								const arrIsCheck = this.props.arrIsCheck.map(() => false);
								this.props.parentStateHandler({ states: ['onExportPDF', 'arrCheckedId', 'arrIsCheck'], newValues: [false, [], arrIsCheck] });
								this.props.closeModal();
							});

						});
					};

					if (
						(params && params.id === 'pdf-export-withoutphoto')
						||
						this.props.selectedItemId === 'pdfBacthExport-withoutphoto'
					) {

						batchExportPDF(batchStock, 0, 0);
					} else {
						batchExportPDF(batchStock, 0, 1);
					}

				} else {
					// 正常edit
					this.loadData(this.props.selectedItemId || params.id);
				}

		}
	}

	componentWillReceiveProps(nextProps) {
		// 一般情況先檢查是否存在
		if (nextProps.params && this.props.params) {
			if (nextProps.params.id !== this.props.params.id) {
				this.loadData(nextProps.params.id)
			}
			// 客戶tab
		} else if (nextProps.selectedItemId) {
			if (nextProps.selectedItemId !== this.props.selectedItemId) {
				this.loadData(nextProps.selectedItemId)
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		// const { parts_data, is_parts_data_loaded } = this.props;
		// 為維持原架構 ===
		// const parts_data = [],
		//       is_parts_data_loaded = true;
		// ======

		const {
			company,
			contact,
			repair_department,
			repair_department_name,
			repair_priority,
			repair_content,
			service_type,
			model_name,
			assign,
			// working_cost,
			// service_cost,
			// tax,
			// discount,
			// car_cost,
			btnSaveDisable,
			status,
			leave_time
		} = this.state;
		// 客製零件編號array
		// if ( is_parts_data_loaded && !is_parts_data_loaded_for_state && is_loaded ) {

		// 	let new_data = parts_data.map((x, y)=>{ return { part_id: x.part_id, part_name: x.part_name, label:  x.part_id + ' - ' + x.part_name, price: x.unit_price, part_spec: x.part_spec } })

		// 	parts.map((x, y)=>{

		// 		if ( x.number !== null ) {

		// 			let find_data = _.find( new_data, { part_id: x.number.part_id } )
		// 			if ( find_data === undefined ) {
		// 				new_data.push({ part_id: x.number.part_id, part_name: x.name, label:  x.number.part_id + ' - ' + x.name, price: x.price, part_spec: x.part_spec, disabled: true })
		// 			}
		// 			else {
		// 				find_data.disabled = true
		// 			}
		// 		}
		// 	})
		// 	this.setState({ parts_data_for_number: new_data, is_parts_data_loaded_for_state: true })
		// }
		if (
			!company ||
			!contact ||
			!repair_content ||
			!repair_department ||
			!repair_priority ||
			!service_type ||
			(
				status === '3' &&
				!leave_time
			)
		) {
			if (!btnSaveDisable) {
				this.setState({ btnSaveDisable: true });
			}
		} else if (btnSaveDisable) {
			this.setState({ btnSaveDisable: false });
		}
		//取得預設負責工程師
		if (
			prevState.repair_department_name !== repair_department_name ||
			prevState.company !== company ||
			prevState.model_name !== model_name
		) {
			if (
				assign.length <= 0 &&
				repair_department_name &&
				company &&
				model_name
			) {
				const companyId = company.id;

				$.ajax({
					type: 'get',
					url: `/api/M_Svc_Area_Search_Get.php?company_id=${companyId}&&department=${repair_department_name}&&machine_name=${model_name}`,
					success: res => {
						const result_data = res.status === '0' ? res.result : [];

						let assign = [];
						_.forEach(result_data, (val, key) => {
							assign.push(val.user_id);
						});
						this.setState({ assign })
					},
					error: (xhr, ajaxOptions, thrownError) => { }
				})
			}
		}
	}

	loadData(id, cb) {
		// 以下cb的配置是為確保此處所有ajax完成之後再執行
		$.ajax({
			type: 'get',
			// url: `/api/W_ServiceSky_RepairSky_Get.php?id=${id}`,
			url: `/api/M_ServiceSky_RepairSky_Get.php?id=${id}`,
			success: res => {
				if (res.status == 0) {
					const result = res.result;

					// let parts = result.parts_list.map((x, y) => {
					// 	return { part_id: x.part_id, name: x.part_name, qty: x.amount, price: x.unit_price, total: x.subtotal, part_spec: x.part_spec, remark: x.remark }
					// })

					this.setState({
						repair_id: result.repair_id,
						canEdit: result.status === '3' ? false : true,
						repair_department: result.repair_department,
						repair_priority: result.repair_priority,
						repair_man_id: result.request_user_id,
						repair_man_name: result.request_user_name,
						status: result.status,
						request_date:
							(
								result.request_date !== '' &&
								result.request_date !== '0000-00-00 00:00:00'
							) ? moment(result.request_date) : null,
						leave_time:
							(
								result.leave_time !== '' &&
								result.leave_time !== '0000-00-00 00:00:00'
							) ? moment(result.leave_time) : null,
						brand: result.brand,
						product_line: result.product_line,
						model_name: result.model_name,
						machine_model: result.machine_model,
						serial_number: result.serial_number,
						serial_number_tmp: result.serial_number,
						customer_id: result.customer_id,
						company_owner: result.company_owner,
						company: { id: result.company_id, name: result.company_name },
						address: result.address,
						contact: { id: result.contact_id, name: result.contact_name },
						contact_phone: result.work_phone,
						contact_email: result.email,
						location: result.location,
						expect_date:
							(
								result.expect_date !== '' &&
								result.expect_date !== '0000-00-00 00:00:00'
							) ? moment(result.expect_date) : null,
						service_type: result.service_type_id,
						assign: result.fix_user_id,
						collaborator: result.teamworker,
						start_date:
							(
								result.start_date !== '' &&
								result.start_date !== '0000-00-00 00:00:00'
							) ? moment(result.start_date) : null,
						repair_date:
							(
								result.repair_date !== '' &&
								result.repair_date !== '0000-00-00 00:00:00'
							) ? moment(result.repair_date) : null,
						repair_hours: result.repair_hours,
						repair_content: result.issue_description,
						problem: result.problem,
						maintain_content: result.solution_description,
						repair_result: result.repair_result,
						satisfactionId: result.satisfaction_id,
						cost_type: result.cost_type,
						message: result.message,
						remarks: result.remark,

						parts: result.parts_list,
						signature_images: result.signature_images,

						// 批次匯出pdf情況下，全部完成才從別處取消讀取動畫
						is_loaded:
							(
								this.props.params &&
								(
									this.props.params.id === 'pdf-export-withoutphoto' ||
									this.props.params.id === 'pdf-export'
								)
							) ? false : true
					}, result.factory_id === '0' ? null : cb);

					// 廠區
					this.loadFactoryData(result.company_id)
					// 聯絡人
					if (result.factory_id === '0') {
						this.loadContactData(result.company_id, result.contact_id, cb);
					} else {
						this.onChangeFactory(result.factory_id, 1);
					}

					// 圖片處理
					let repair_orinFiles =
						(result.issue_images || [])
							.concat(result.issue_pdfs || [])
							.concat(result.issue_videos || [])
							.concat(result.issue_words || [])
							.concat(result.issue_excels || [])
							.concat(result.issue_powerpoints || []),
						maintain_orinFiles =
							(result.solution_images || [])
								.concat(result.solution_pdfs || [])
								.concat(result.solution_videos || [])
								.concat(result.solution_words || [])
								.concat(result.solution_excels || [])
								.concat(result.solution_powerpoints || []),
						repair_downloadedFiles = this.fileFilter(repair_orinFiles),
						maintain_downloadedFiles = this.fileFilter(maintain_orinFiles);

					onFileDrop2(repair_downloadedFiles, '', this, true, '', 'repair_preview');
					onFileDrop2(maintain_downloadedFiles, '', this, true, '', 'maintain_preview');
				} else {
					this.props.closeModal()
				}
			},
			error: (xhr, ajaxOptions, thrownError) => { }
		});
	}

	loadFactoryData(company_id) {
		const { factory_data } = this.props;

		let result_data = _.filter(factory_data, { company_id: company_id }).length === 0 ? [] : _.filter(factory_data, { company_id: company_id });

		this.setState({ factory_data: result_data })
	}

	loadContactData(company_id, contact_id, cb) {
		$.ajax({
			type: 'get',
			url: `/api/M_SaleSky_Contacts.php?company_id=${company_id}`,
			success: res => {
				const result_data =
					res.status === '0'
						? res.result
						: [];

				this.setState({ contact_data: result_data }, cb);

				if (result_data.length > 0) {
					const contact = _.find(result_data, { id: contact_id });

					this.onChangeContact(contact_id !== '0' && contact ? contact : result_data[0]);
				} else this.onChangeContact(null);
			},
			error: (xhr, ajaxOptions, thrownError) => { }
		})
	}

	// loadProductData(id) {
	// 	$.ajax({
	// 		type: 'get',
	// 		url: `/api/M_SaleSky_ShippingRecord_Get.php?company_id=${id}`,
	// 		success: res => {
	// 			this.setState({ product_data: res.result, product_model: null });
	// 		},
	// 		error: (xhr, ajaxOptions, thrownError) => { }
	// 	});
	// }

	timeOption(unit) {
		let array = [];

		for (let i = 0; i < unit; i++) {
			i < 10 ? array.push(`0${i}`) : array.push(i.toString())
			// array.push(i.toString())
		}

		return array.map((x, y) => <option key={y} value={x}>{x}</option>)
	}

	onChangeRepairMan(option) {
		const repair_man_id = (option === null || option.length === 0) ? '' : option.id,
			repair_man_name = (option === null || option.length === 0) ? '' : option.name;

		this.setState({ repair_man_id, repair_man_name })
	}

	onChangeCompany(option) {
		let company_id = (option === null || option.length === 0) ? '' : option.id,
			company_name = (option === null || option.length === 0) ? '' : option.name,
			address = (option === null || option.length === 0) ? '' : option.address || '';

		this.setState({
			company: option,
			address,
			contact: null,
			factory: '0',
			receipt_title: company_name
		})

		this.loadContactData(company_id, option.contact_id ? option.contact_id : '');
		this.loadFactoryData(company_id);
	}

	onChangeFactory(value, keepInfo) {
		if (value === '0') {
			this.loadContactData(this.state.company.id);

			// 清空資訊
			this.setState({
				contact: null,
				contact_phone: '',
				contact_mobile: '',
				contact_email: '',
				factory: value,
				address: this.state.company.address
			});
			return;
		}

		const { factory_data } = this.props;

		let find_data = _.find(factory_data, { company_id: this.state.company.id, factory_id: value }),
			address = find_data === undefined ? '' : find_data.address,
			contacts = find_data === undefined ? [] : find_data.contacts;

		contacts.map((x, y) => {
			x.id = x.contact_id || x.id;
			x.name = x.contact_name || x.name;
			return x
		})

		const contact = keepInfo ? {} : { contact: null };

		this.setState({ factory: value, address: address, ...contact, contact_data: contacts })

		if (keepInfo) return;
		this.onChangeContact(null)
	}

	onChangeContact(option) {
		let is_error = false, email = '', work_phone = '', cell_phone = '';
		if (option !== null) {
			if (option.length !== 0) {
				email = option.email
				work_phone = option.work_phone
				cell_phone = option.cell_phone
			} else option = null
		}

		is_error = option === null ? true : false

		this.setState({
			contact: option,
			contact_phone: work_phone || '',
			contact_mobile: cell_phone || '',
			contact_email: email || '',
			is_error: is_error
		})
	}

	// onChangeTotalAmount() {
	// 	let { parts, working_cost, service_cost, tax, discount, car_cost } = this.state

	// 	let parts_total = 0, tax_total = 0;
	// 	parts.map((x, y) => parts_total += parseInt(x.subtotal, 10))
	// 	let subtotal = (parts_total === '' ? 0 : parseInt(parts_total, 10)) + (car_cost === '' ? 0 : parseInt(car_cost, 10)) + (working_cost === '' ? 0 : parseInt(working_cost, 10)) + (service_cost === '' ? 0 : parseInt(service_cost, 10)) - discount;
	// 	// let subtotal = (car_cost === '' ? 0 : parseInt(car_cost, 10)) + (working_cost === '' ? 0 : parseInt(working_cost, 10)) + (service_cost === '' ? 0 : parseInt(service_cost, 10)) - discount;
	// 	if (subtotal < 0) subtotal = 0;

	// 	tax_total = Math.round(subtotal * (tax / 100));

	// 	let total_amount = subtotal * (1 + tax / 100)
	// 	total_amount = Math.round(total_amount)

	// 	this.setState({ subtotal: subtotal, total_amount: total_amount, parts_total, tax_total })
	// }

	// onChangePartNumber(option, index) {
	// 	// const { parts_data } = this.props
	// 	const { parts, parts_data_for_number } = this.state

	// 	// 解除disable
	// 	if (parts[index].number !== null) {

	// 		let find_data = _.find(parts_data_for_number, { part_id: parts[index].number.part_id })
	// 		find_data === undefined ? null : find_data.disabled = false
	// 	}

	// 	// 檢查option值 必須先檢查是否為null
	// 	if (option !== null) {

	// 		// 檢查是否為空值
	// 		if (option.length === 0) option = null;
	// 		else {
	// 			option.disabled = true
	// 			// parts[index].name = _.find( parts_data_for_number, { part_id: option.part_id } ) !== undefined ? option.part_name : null
	// 			parts[index].part_name = option.part_name || ''
	// 			parts[index].price = option.price || 0
	// 			parts[index].part_spec = option.part_spec || ''
	// 			parts[index].qty = '1'
	// 			parts[index].total = option.price || 0
	// 		}
	// 	}

	// 	if (option === null) {

	// 		parts[index].name = ''
	// 		parts[index].price = '0'
	// 		parts[index].part_spec = ''
	// 		parts[index].qty = '0'
	// 		parts[index].total = '0'
	// 	}

	// 	let is_error = false
	// 	// 是否重複或空值
	// 	if (_.find(parts, { number: option }) !== undefined) {

	// 		is_error = true
	// 	}

	// 	parts[index].is_double = _.find(parts, { number: option }) === undefined ? false : true
	// 	parts[index].number = option
	// 	// let pulled = _.pull( parts_data, option )

	// 	this.setState({ parts: parts, is_error: is_error })
	// 	this.onChangeTotalAmount()
	// }

	// onChangePartName ( option, index ) {

	// 	const { parts } = this.state

	// 	// 檢查option值 必須先檢查是否為null
	// 	if ( option !== null ) {
	// 		// 檢查是否為空值
	// 		if ( option.length === 0 ) {
	// 			// 改成null
	// 			option = null
	// 		}
	// 	}

	// 	parts[index].name = option

	// 	this.setState({ parts: parts })
	// }

	onPageChange(direction) {
		const { filter_data, params, selectedItemId, selectedRowIndex, parentStateHandler } = this.props

		let data_length = filter_data.length,
			id = params ? params.id : selectedItemId;
		if (direction === 'next') {
			let find_index = _.findIndex(filter_data, { id });
			id = find_index < data_length - 1 ? filter_data[(find_index + 1)].id : id
		} else if (direction === 'prev') {
			let find_index = _.findIndex(filter_data, { id });
			id = find_index > 0 ? filter_data[(find_index - 1)].id : id
		}

		if (this.props.params) browserHistory.push(`/salesky/online-repair-service/${id}`);
		else this.loadData(id);

		// 更新選定id以及row
		if (!params) {
			const row = direction === 'next' ? selectedRowIndex + 1 : selectedRowIndex - 1;

			if (row < 0) row = 0;
			else if (row > data_length - 1) row = data_length - 1;

			parentStateHandler({
				states: ['selectedItemId', 'selectedRowIndex'],
				newValues: [id, row]
			});
		}
	}

	onSubmit() {
		const { route, params } = this.props;

		let mode;
		// 編輯情境
		if ((this.props.params && this.props.params.id) || this.props.selectedItemId) {
			mode = 'edit';
			// 新增情境
		} else mode = 'add';

		const {
			repair_id,
			repair_department,
			repair_priority,
			repair_man_id,
			repair_man_name,
			status,
			brand,
			product_line,
			company,
			address,
			contact,
			contact_phone,
			contact_email,
			product_model,
			serial_number,
			customer_id,
			company_owner,
			model_name,
			machine_model,
			assign,
			collaborator,
			location,
			service_type,
			repair_hours,
			repair_content,
			maintain_content,
			problem,
			repair_result,
			satisfactionId,
			cost_type,
			message,
			remarks,
			parts,
			request_date,
			leave_time,
			expect_date,
			start_date,
			repair_date
		} = this.state;

		const newParts = _.filter(parts, function (o) { return o.itemFlag !== 'delete' });

		// 整理格式
		// let new_parts = '',
		// 	parts_error = false;
		// newParts.map((x, y) => {
		// 	if (!(x.part_id === '' && x.part_name === '' && x.part_spec === '' && x.unit_price === 0 && x.amount === 0 && x.subtotal === 0)) {	//當有欄位不為空或0的時候
		// 		new_parts += x.part_id + '∞' + x.part_name + '∞' + x.amount + '∞' + x.unit_price + '∞' + x.subtotal + '∞' + x.part_spec + '∞' + x.remark + '|'
		// 	}
		// })
		// new_parts = new_parts.substr(0, (new_parts.length - 1));

		// if (repair_content === '' || contact === null || parts_error) {
		// 	alert('尚有欄位還未填寫')
		// 	this.setState({ is_error: true })
		// } else {
		let formData = new FormData();

		formData.append('repair_department', repair_department);
		formData.append('repair_priority', repair_priority);
		formData.append('request_user_id', repair_man_id || this.props.user_id);				//報修人員ID
		formData.append('request_user_name', repair_man_name || this.props.user_name);		//報修人員
		// =======================================================
		// =======================================================
		formData.append('status', status);
		formData.append('brand', brand);
		formData.append('product_line', product_line);
		// if (product_model) {
		// 	formData.append('model_id', product_model.id);
		// 	formData.append('model_name', product_model.name);
		// } else {
		// 	formData.append('model_id', 0);
		// 	formData.append('model_name', '');
		// }
		formData.append('model_name', model_name);
		formData.append('machine_model', machine_model);
		formData.append('serial_number', serial_number);
		formData.append('customer_id', customer_id);
		formData.append('company_owner', company_owner);
		formData.append('company_id', company.id);
		formData.append('company_name', company.name);
		formData.append('address', address);
		formData.append('contact_id', contact.id);
		formData.append('contact_name', contact.name);
		formData.append('contact_phone', contact_phone);
		formData.append('contact_email', contact_email);
		formData.append('location', location);
		formData.append('service_type_id', service_type);
		formData.append('fix_user_id', assign);
		formData.append('teamworker', collaborator);
		formData.append('repair_hours', repair_hours);
		formData.append('issue_description', repair_content);
		formData.append('problem', problem);
		formData.append('solution_description', maintain_content);
		formData.append('repair_result', repair_result);
		formData.append('satisfaction_id', satisfactionId);
		formData.append('cost_type', cost_type);
		formData.append('message', message);
		formData.append('remark', remarks);
		// formData.append('parts_list', new_parts);	// 原本是parts_list
		if (newParts.length > 0) {
			_.forEach(newParts, (val, key) => {
				formData.append(`parts_list[${key}][part_id]`, val.part_id);
				formData.append(`parts_list[${key}][part_name]`, val.part_name || '');
				formData.append(`parts_list[${key}][part_spec]`, val.part_spec || '');
				formData.append(`parts_list[${key}][amount]`, val.amount || 0);
				formData.append(`parts_list[${key}][unit_price]`, val.unit_price || 0);
				formData.append(`parts_list[${key}][subtotal]`, val.subtotal || 0);
				formData.append(`parts_list[${key}][remark]`, val.remark || '');
			});
		}
		if (request_date !== null) formData.append('request_date', request_date !== null ? request_date.format('YYYY-MM-DD') : '');
		if (expect_date !== null) formData.append('expect_date', expect_date !== null ? expect_date.format('YYYY-MM-DD') : '');
		if (start_date !== null) formData.append('start_date', start_date !== null ? `${start_date.format('YYYY-MM-DD HH:mm')}:00` : '');
		if (repair_date !== null) formData.append('repair_date', repair_date !== null ? `${repair_date.format('YYYY-MM-DD HH:mm')}:00` : '');
		if (leave_time !== null) formData.append('leave_time', leave_time !== null ? leave_time.format('YYYY-MM-DD') : '');

		if (mode === 'edit') formData.append('repair_id', repair_id)

		// 不存在的聯絡人先新增(停用)
		// if (contact.className) {
		// 	const contactFormData = new FormData();

		// 	let url, nameKey;
		// 	if (this.state.factory === '0') {
		// 		url = 'W_SaleSky_Contacts_Post.php';
		// 		nameKey = 'name';
		// 	} else {
		// 		url = 'W_ServiceSky_Factory_Contacts_Post.php';
		// 		nameKey = 'contact_name';
		// 		contactFormData.append('factory_id', this.state.factory);
		// 	}

		// 	contactFormData.append(nameKey, contact.name);
		// 	contactFormData.append('company_id', company.id);
		// 	contactFormData.append('work_phone', this.state.contact_phone || '');
		// 	contactFormData.append('cell_phone', this.state.contact_mobile || '');
		// 	contactFormData.append('email', this.state.contact_email || '');

		// 	$.ajax({
		// 		type: 'post',
		// 		url: `/api/${url}`,
		// 		data: contactFormData,
		// 		processData: false,
		// 		contentType: false,
		// 		success: res => {
		// 			if (res.status === '0') {
		// 				const newContact = res.result[0];

		// 				if (this.state.factory !== '0') {
		// 					const { factory_data } = this.props

		// 					const find_data =
		// 						_.find(factory_data, { factory_id: this.state.factory }),
		// 						ind = _.findIndex(find_data.contacts, { id: contact.name });

		// 					find_data.contacts.splice(ind, 1, newContact);
		// 				}

		// 				formData.append('contact_id', newContact.id || newContact.contact_id);
		// 				this.doSaveAJAX(formData);
		// 			}
		// 		},
		// 		error: error => { }
		// 	});
		// } else {
		// 	formData.append('contact_id', contact.id);
		// 	this.doSaveAJAX(formData);
		// }
		this.doSaveAJAX(formData);
		// }
	}

	uploadFiles(type, id) {
		this.refs.uploading.style.display = 'inline-block';

		const { repair_content_files, maintain_content_files } = this.state;

		let upload_files = []
		if (type === 'RepairIssue')
			upload_files = repair_content_files
		else if (type === 'RepairSolution')
			upload_files = maintain_content_files

		let fileData = new FormData()
		fileData.append('type', type)
		fileData.append('file_id', id);

		for (let i = 0; i < upload_files.length; i++) {
			fileData.append('$_FILES', upload_files[i])

			$.ajax({
				async: false,
				type: 'POST',
				data: fileData,
				processData: false,
				contentType: false,
				url: '/api/M_SaleSky_FileUpload_Post.php',
				success: res => { },
				error: (xhr, ajaxOptions, thrownError) => { }
			});
		}

		this.refs.uploading.style.display = 'none';
		// this.props.closeModal();
	}

	deleteFiles(type, id) {
		this.refs.uploading.style.display = 'inline-block';

		const { delete_repair_files, delete_maintain_files } = this.state;

		let delete_files = [];
		if (type === 'RepairIssue') delete_files = delete_repair_files
		else if (type === 'RepairSolution') delete_files = delete_maintain_files

		let fileData = new FormData()
		fileData.append('type', type)

		for (let i = 0; i < delete_files.length; i++) {
			fileData.append('id', delete_files[i].file_id)

			$.ajax({
				async: false,
				type: 'POST',
				data: fileData,
				processData: false,
				contentType: false,
				url: '/api/M_SaleSky_FileDelete_Post.php',
				success: res => { },
				error: (xhr, ajaxOptions, thrownError) => { }
			});
		}

		this.refs.uploading.style.display = 'none'
		// this.props.closeModal();
	}

	addPart() {
		const { parts } = this.state;

		parts.push(Object.assign({}, part_obj))
		this.setState({ parts })
	}

	removePart(index) {
		const { parts } = this.state;

		let newPartsList = _.filter(parts, function (n) { return n.itemFlag !== 'delete'; });
		newPartsList[index].itemFlag = 'delete';
		_.uniq(parts, newPartsList);

		this.setState({ parts })
	}

	// isEmail(email) {
	// 	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	// 	return re.test(email);
	// }

	// addLeftZero(str, length) {
	// 	return new Array(length - str.length + 1).join('0') + str;
	// }

	// formatInt(value) {
	// 	const value_ = removeCommasToNumber(value).toString();

	// 	let int_value = value_.replace(/\D/g, '');
	// 	return int_value === '' ? 0 : parseInt(int_value, 10).toString();
	// }

	filterOptions(optsObjArr, stringFilter, selectedOptions) {
		const vaildOptions = _.difference(optsObjArr, selectedOptions);
		// 轉小寫的選項arr應該以state存起來避免每次重運算，只在opts更新時做更新
		// 如果運算loading相對小，不儲存可以節省記憶體，依情境取捨
		let filteredOptsObjArr = [];
		if (stringFilter) {
			let stringFilterLowerCase = stringFilter.toLowerCase();

			_.forEach(vaildOptions, (val, key) => {
				if (
					(
						val.name &&
						val.name.toLowerCase().indexOf(stringFilterLowerCase) !== -1
					) ||
					(
						val.label &&
						val.label.toLowerCase().indexOf(stringFilterLowerCase) !== -1
					)
				) {
					filteredOptsObjArr.push(val);
				}
			});
		} else {
			filteredOptsObjArr = vaildOptions;
		}

		return filteredOptsObjArr;
	}

	render() {
		const { languageData, languageCode } = window.myConsts;

		const {
			closeModal,
			status_data,
			basic_data,
			brand_data,
			repair_man_data,
			user_data,
			assign_data,
			company_data,
			// service_type_data,
			service_result_data
		} = this.props;

		const {
			repair_id,
			showSearchCompanyContactModal,
			showSearchSNResult,
			selectSNValue,
			serialNumberList,
			repair_department,
			repair_priority,
			request_date,
			leave_time,
			brand,
			product_line,
			model_name,
			machine_model,
			customer_id,
			company_owner,
			repair_man_id,
			repair_man_name,
			location,
			expect_date,
			create_user,
			enableEdit,
			is_loaded,
			status,
			repair_date,
			repair_hours,
			company,
			address,
			contact,
			contact_data,
			contact_phone,
			contact_email,
			serial_number,
			service_type,
			assign,
			collaborator,
			start_date,
			repair_content,
			repair_content_files,
			repair_preview,
			maintain_content,
			maintain_content_files,
			maintain_preview,
			problem,
			repair_result,
			satisfactionId,
			parts,
			cost_type,
			message,
			remarks,
			signature_images,
			canEdit,
			showPdfContent,
			btnSaveDisable,
			activeTabKey
		} = this.state;

		let title = '', btnExportPDF, mode, repair_man = repair_man_id, userName = create_user;
		// 編輯情境
		if ((this.props.params && this.props.params.id) || this.props.selectedItemId) {
			mode = 'edit';
			// 新增情境
		} else {
			mode = 'add';
		}

		switch (mode) {
			case 'add':
				title = <div className='textLineHeight' style={{ fontSize: 18, fontWeight: 500 }}>{languageData['461'][languageCode]}</div>;
				userName = this.props.user_name;
				repair_man = repair_man || (_.filter(repair_man_data, ['id', this.props.user_id])[0] ? _.filter(repair_man_data, ['id', this.props.user_id])[0].id : '');
				break;
			case 'edit':
				// 報修人員若不在選單中，新增一筆
				if (_.filter(repair_man_data, ['id', repair_man_id]).length <= 0 && repair_man_id !== '') {
					repair_man_data.push({ 'id': repair_man_id, 'name': repair_man_name, 'group_name': '', 'job_title': '', 'photo': '', 'user_group': '' })
				} else {
					repair_man = _.filter(repair_man_data, ['id', repair_man_id]).length > 0 ? _.filter(repair_man_data, ['id', repair_man_id])[0] : '';
				}

				if (!enableEdit) {
					title = <div className='textLineHeight' style={{ fontSize: 18, fontWeight: 500 }}>{languageData['449'][languageCode]}</div>;
					btnExportPDF = <DeleteBtnWithConfirm
						btnTitle={showPdfContent ? languageData['474'][languageCode] : languageData['473'][languageCode]}
						title={languageData['411'][languageCode]}
						style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}
						onClick={this.onExportPdfWithPhotoClick}
						onCancelClick={this.onExportPdfWithoutPhotoClick} />;

				} else {
					title = <div className='textLineHeight' style={{ fontSize: 18, fontWeight: 500 }}>{languageData['77'][languageCode]}</div>;
				}
				break;

			default:
		}

		// canEdit 依據是否已結案，editPermission 依據權限
		const editPermission = this.props.userPermission.salesky_repair_web * 1 > 2 ||
			this.props.userPermission.servicesky_repair_web * 1 > 2,
			// editControl = canEdit && editPermission;
			editControl = true,
			newParts = _.filter(parts, function (o) { return o.itemFlag !== 'delete' });

		let btnSaveDisableStr = '';
		if (repair_department.length === 0) btnSaveDisableStr += '需求單位、';
		if (!repair_priority) btnSaveDisableStr += '件別、';
		if (!company) btnSaveDisableStr += '客戶全稱、';
		if (!contact) btnSaveDisableStr += '聯絡人員、';
		if (!service_type) btnSaveDisableStr += '類別、';
		if (!repair_content) btnSaveDisableStr += '叫修內容 (概要)、';
		if (status === '3' && !leave_time) btnSaveDisableStr += '結案日期、';
		let btn_save =
			enableEdit ?
				<Button
					onClick={() => this.onSubmit()}
					disabled={!editControl || btnSaveDisable}
					style={{ position: 'relative' }}>
					{languageData['76'][languageCode]}
					{
						btnSaveDisableStr ?
							<Tooltip
								placement='left'
								tipText={`請檢查 ${btnSaveDisableStr.substr(0, btnSaveDisableStr.length - 1)}`}
								onClick={e => { e.stopPropagation(); }}
							/>
							: ''
					}
				</Button>
				:
				<Button
					onClick={() => this.setState({ enableEdit: true })}
					disabled={!editControl || btnSaveDisable}
					style={{ position: 'relative' }}>
					{languageData['77'][languageCode]}
					{
						!editControl ?
							<Tooltip
								placement='left'
								tipText={canEdit ? '您無編輯權限' : '已結案不可編輯'}
								onClick={e => { e.stopPropagation(); }}
							/>
							: ''
					}
				</Button>

		let btn_copy = enableEdit ? '' : <Button onClick={closeModal} style={{ display: 'none' }}>{languageData['462'][languageCode]}</Button>
		let btn_prev_page = enableEdit ? '' : <Button className='btn_page' onClick={() => this.onPageChange('prev')}>{languageData['450'][languageCode]}</Button>
		let btn_next_page = enableEdit ? '' : <Button className='btn_page' onClick={() => this.onPageChange('next')}>{languageData['451'][languageCode]}</Button>
		let btn_cancel_text = enableEdit ? languageData['55'][languageCode] : languageData['452'][languageCode]


		let repairPdfContent = null;
		if (showPdfContent) {
			repairPdfContent = this.pdfContentCreater();
		}

		// 匯出pdf時不顯示ui
		let isPDFBatchExport;
		if (mode !== 'add') {
			if (
				(
					this.props.params &&
					(
						this.props.params.id === 'pdf-export' ||
						this.props.params.id === 'pdf-export-withoutphoto'
					)
				) ||
				this.props.selectedItemId.indexOf('pdfBacthExport') !== -1
			) {
				isPDFBatchExport = true;
			}
		}

		const nextTabDisable = !Boolean(contact && repair_content),
			repair_department_list = [
				{ id: 'Support', name: 'Support' },
				{ id: 'Sales', name: 'Sales' },
				{ id: 'Service', name: 'Service' }
			],
			repair_priority_list = [
				{ id: '急件', name: '急件' },
				{ id: '普通件', name: '普通件' }
			];

		return (
			<div>
				<Uploading ref='uploading' isShow={!is_loaded} />

				<Modal
					show={true}
					bsSize='large'
					style={isPDFBatchExport ? { display: 'none' } : null}
					className='modal_online_repair'
					onHide={closeModal}
					keyboard={false}
					backdrop='static'>
					<Modal.Header>
						<div className='modal_title'>{title}</div>
						<div style={{ justifyContent: 'center' }}>
							{btn_prev_page}
							{btn_next_page}
						</div>
						<div style={{ justifyContent: 'flex-end' }}>
							{btn_save}
							{/* {btnExportPDF}
							{btn_copy} */}
							<Button onClick={closeModal}>{btn_cancel_text}</Button>
						</div>
					</Modal.Header>
					<Modal.Body>
						{/* tab 切割內容 */}
						<Row style={{ marginBottom: 15 }}>
							{/* repair_id */}
							<Col sm={12}>
								<div style={{ marginBottom: 5, fontWeight: 'Bold' }}>{'維修單編號 '}<span style={{ color: '#ff0000' }}>{repair_id}</span></div>
							</Col>
							<Col sm={12}>
								<div style={{ marginBottom: 5, fontWeight: 'Bold' }}>{'基本資料'}</div>
							</Col>
							<Col sm={12}>
								<Well style={{ marginBottom: 15 }}>
									<Row>
										<DropDownMenu
											sm={3}
											required={true}
											label={'需求單位'}
											multi={true}
											disabled={!enableEdit}
											stateName='repair_department'
											value={repair_department}
											valueKey='id'
											labelKey='name'
											onChange={this.handlers.onChange}
											// onChange={(option) => this.setState({ repair_department: option.id })}
											options={repair_department_list} />
										<DropDownMenu
											sm={3}
											required={true}
											label={'件別'}
											disabled={!enableEdit}
											stateName='repair_priority'
											value={repair_priority}
											valueKey='id'
											labelKey='name'
											onChange={(option) => this.setState({ repair_priority: option.id })}
											options={repair_priority_list}
											filterOptions={this.filterOptions} />
										<DropDownMenu
											sm={3}
											required={true}
											label={'申請人'}
											disabled={!enableEdit}
											stateName='repair_man'
											value={repair_man}
											valueKey='id'
											labelKey='name'
											onChange={(option) => this.onChangeRepairMan(option)}
											options={repair_man_data}
											filterOptions={this.filterOptions} />
										<DropDownMenu
											sm={3}
											label={'狀態'}
											disabled={!enableEdit || mode === 'add'}
											stateName='status'
											value={status}
											valueKey='id'
											labelKey='name'
											onChange={(option) => this.setState({ status: option.id })}
											options={status_data}
											filterOptions={this.filterOptions} />
									</Row>
									<Row>
										<DayPicker
											id='request_date'
											showTimeSelect={true}
											labelFontWeight='bold'
											sm={3}
											outerLabel={'填單日期'}
											disabled={!enableEdit}
											onChange={(date) => this.setState({ request_date: date }, () => {
												$('#request_date').click();
											})}
											dayStateName='request_date'
											dayValue={request_date} />
										{/* <Col sm={3}>
											<FormGroup controlId='repairDateTime' style={{ margin: 0 }}>
												<ControlLabel>{languageData['164'][languageCode]}</ControlLabel>
												<DatePicker
													id='repairDateTime'
													// onKeyDown={(date) => {
													// 	this.handlers.dayPick(date, 'repair_date', true);
													// }}
													// onBlur={(date) => {
													// 	this.handlers.dayPick(date, 'repair_date', true);
													// }}
													onChange={(date) => {
														this.setState({ repair_date: date }, () => {
															$('#repairDateTime').click();
														});
													}}
													selected={request_date}
													disabled={!enableEdit}
													className='form-control datepicker-style'
													disabledKeyboardNavigation={true}
													showTimeSelect={true}
													timeFormat='HH:mm'
													timeIntervals={10}
													timeCaption='time'
													dateFormat='YYYY-MM-DD HH:mm'
													placeholderText={'Pick a date here'}
													peekNextMonth
													showMonthDropdown
													showYearDropdown
													dropdownMode='select' />
											</FormGroup>
										</Col> */}
										<DropDownMenu
											sm={6}
											label={'廠牌'}
											disabled={!enableEdit}
											stateName='brand'
											value={brand}
											valueKey='brand_name'
											labelKey='brand_name'
											onChange={(option) => this.setState({ brand: option.brand_name, product_line: option.product_line })}
											options={brand_data}
											filterOptions={this.filterOptions} />
										{/* <Col sm={6}>
											<FormGroup controlId='brand'>
												<ControlLabel style={{ fontWeight: 'bold' }}>廠牌</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={brand}
													style={{ height: 36 }} />
											</FormGroup>
										</Col> */}
										<DropDownMenu
											sm={3}
											label={'產品線'}
											disabled={!enableEdit}
											stateName='brand'
											value={product_line}
											valueKey='product_line'
											labelKey='product_line'
											onChange={(option) => this.setState({ brand: option.brand_name, product_line: option.product_line })}
											options={brand_data}
											filterOptions={this.filterOptions} />
										{/* <Col sm={3}>
											<FormGroup controlId='product_line'>
												<ControlLabel style={{ fontWeight: 'bold' }}>產品線</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={product_line}
													style={{ height: 36 }} />
											</FormGroup>
										</Col> */}
									</Row>
									<Row>
										<Col sm={6}>
											<FormGroup controlId='model_name'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'儀器名稱'}</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={model_name}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										<Col sm={3}>
											<FormGroup controlId='machine_model'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'儀器型號'}</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={machine_model}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										<Col sm={3}>
											<FormGroup controlId='serial_number' style={{ position: 'relative' }}>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'儀器序號'}</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={serial_number}
													style={{ height: 36 }} />
												{
													enableEdit ?
														<img role='img' src='/imgs/ic_search_nor.svg' alt='' className='text-center'
															style={{ position: 'absolute', top: 30, right: 5, width: 25, height: 25, cursor: 'pointer' }} onClick={() => { this.handlers.onSNLoadCompanyData() }} />
														: null
												}
											</FormGroup>
										</Col>
									</Row>
									<Row>
										<Col sm={3}>
											<FormGroup controlId='customer_id'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'客戶編號'}</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={customer_id}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										<Col sm={3}>
											<FormGroup controlId='company_owner'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'負責人'}</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={company_owner}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										<DropDownMenu
											sm={6}
											required={true}
											label={'客戶全稱'}
											disabled={!enableEdit}
											stateName='company'
											value={company}
											valueKey='id'
											labelKey='name'
											showSearchCompanyContactModal={(e) => this.handlers.onShowSearchCompanyContactModal(1)}
											onChange={(option) => this.onChangeCompany(option)}
											options={company_data}
											filterOptions={this.filterOptions} />
									</Row>
									<Row>
										<Col sm={6}>
											<FormGroup controlId='address'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'客戶地址'}</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={address}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										<DropDownMenu
											sm={3}
											required={true}
											label={'聯絡人'}
											disabled={!enableEdit}
											stateName='contact'
											value={contact}
											valueKey='id'
											labelKey='name'
											onChange={(option) => this.onChangeContact(option)}
											options={contact_data}
											filterOptions={this.filterOptions} />
										<Col sm={3}>
											<FormGroup controlId='contact_phone'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'聯絡電話'}</ControlLabel>
												<FormControl
													disabled={true}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={contact_phone}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
									</Row>
									<Row>
										<Col sm={6}>
											<FormGroup controlId='contact_email'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'Email'}</ControlLabel>
												<FormControl
													disabled={true}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={contact_email}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										<Col sm={3}>
											<FormGroup controlId='location'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'機台位置'}</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={location}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										<DayPicker
											labelFontWeight='bold'
											sm={3}
											outerLabel={'期望前往日期'}
											disabled={!enableEdit}
											onChange={(date) => this.setState({ expect_date: date })}
											dayStateName='expect_date'
											dayValue={expect_date} />
									</Row>
								</Well>
							</Col>

							<Col sm={12}>
								<div style={{ marginBottom: 5, fontWeight: 'Bold' }}>{'維修資訊'}</div>
							</Col>
							<Col sm={12}>
								<Well style={{ marginBottom: 15 }}>
									<Row>
										<DropDownMenu
											sm={4}
											label={'類別'}
											required={true}
											disabled={!enableEdit}
											stateName='service_type'
											value={service_type}
											valueKey='key'
											labelKey='name'
											onChange={(option) => this.setState({ service_type: option.key })}
											options={_.filter(basic_data, { group_name: 'repair_service_type_id' })} />
										<DropDownMenu
											sm={4}
											label={'負責工程師'}
											multi={true}
											disabled={!enableEdit}
											stateName='assign'
											value={assign}
											valueKey='user_id'
											labelKey='user_name'
											onChange={this.handlers.onChange}
											// onChange={(option) => this.setState({ assign: option.user_id })}
											options={_.orderBy(assign_data, ['user_id'], ['asc'])} />
										<DropDownMenu
											sm={4}
											label={'CC人員'}
											multi={true}
											disabled={!enableEdit}
											stateName='collaborator'
											value={collaborator}
											valueKey='id'
											labelKey='name'
											onChange={this.handlers.onChange}
											// onChange={(option) => this.setState({ collaborator: option.user_id })}
											options={_.orderBy(repair_man_data, ['name'], ['asc'])} />
									</Row>
									<Row>
										<DayPicker
											id='startDate'
											showTimeSelect={true}
											labelFontWeight='bold'
											sm={4}
											outerLabel={'安排/維修日期'}
											disabled={!enableEdit}
											onChange={(date) => this.setState({ start_date: date }, () => {
												$('#startDate').click();
											})}
											dayStateName='start_date'
											dayValue={start_date} />
										<DayPicker
											id='repairDate'
											showTimeSelect={true}
											labelFontWeight='bold'
											sm={4}
											outerLabel={'離開日期'}
											disabled={!enableEdit}
											onChange={(date) => this.setState({ repair_date: date }, () => {
												$('#repairDate').click();
											})}
											dayStateName='repair_date'
											dayValue={repair_date} />
										<Col sm={4}>
											<FormGroup controlId='repair_hours'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'維修天數'}</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={repair_hours}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
									</Row>
									<Row>
										<Col sm={12}>
											<FormGroup controlId='repair_content'>
												<ControlLabel style={{ fontWeight: 'bold' }}><RequiredMark />{'叫修內容 (概要)'}</ControlLabel>
												<TextareaWithLink
													disabled={!enableEdit}
													value={repair_content}
													onChange={(event) => this.setState({ repair_content: event.target.value })}
													componentClass='textarea'
													rows={
														repair_content
															? repair_content.split(/[\n]/gm).length > 5
																? repair_content.split(/[\n]/gm).length
																: 5
															: 5
													}
												/>
												{/* <FormControl
													disabled={!enableEdit}
													value={repair_content}
													onChange={(event) => this.setState({ repair_content: event.target.value })}
													componentClass='textarea'
													style={{ height: 100 }} /> */}
											</FormGroup>
										</Col>
										<Col sm={12}>
											<FormGroup controlId='problem'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'叫修或處理內容詳述(記錄用/不顯示於報告)'}</ControlLabel>
												<TextareaWithLink
													disabled={!enableEdit}
													value={problem}
													onChange={(event) => this.setState({ problem: event.target.value })}
													componentClass='textarea'
													rows={
														problem
															? problem.split(/[\n]/gm).length > 5
																? problem.split(/[\n]/gm).length
																: 5
															: 5
													}
												/>
												{/* <FormControl
													disabled={!enableEdit}
													value={problem}
													onChange={(event) => this.setState({ problem: event.target.value })}
													componentClass='textarea'
													style={{ height: 100 }} /> */}
											</FormGroup>
										</Col>
										<Col sm={12}>
											<div style={{ fontWeight: 'Bold', marginBottom: 5 }}>{'附件'}</div>
											<Well>
												<Row>
													<div className={enableEdit ? 'upload' : 'upload preview'}>
														<FileDropAreaCt
															accept='image/jpeg, image/png, application/pdf, video/mp4'
															disabled={!enableEdit}
															uploadedFiles={repair_content_files}
															downloadedFilesPreview={repair_preview}
														/>
													</div>
												</Row>
											</Well>
										</Col>
										<Col sm={12}>
											<FormGroup controlId='maintain_content'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'處理狀況'}</ControlLabel>
												<TextareaWithLink
													disabled={!enableEdit}
													value={maintain_content}
													onChange={(event) => this.setState({ maintain_content: event.target.value })}
													componentClass='textarea'
													rows={
														maintain_content
															? maintain_content.split(/[\n]/gm).length > 5
																? maintain_content.split(/[\n]/gm).length
																: 5
															: 5
													}
												/>
												{/* <FormControl
													disabled={!enableEdit}
													value={maintain_content}
													onChange={(event) => this.setState({ maintain_content: event.target.value })}
													componentClass='textarea'
													style={{ height: 100 }} /> */}
											</FormGroup>
										</Col>
										<Col sm={12}>
											<div style={{ fontWeight: 'Bold', marginBottom: 5 }}>{'附件'}</div>
											<Well>
												<Row>
													<div className={enableEdit ? 'upload' : 'upload preview'}>
														<FileDropAreaCt
															accept='image/jpeg, image/png, application/pdf, video/mp4, .xlsx, .doc, .docx, .ppt, .pptx'
															disabled={!enableEdit}
															uploadedFiles={maintain_content_files}
															downloadedFilesPreview={maintain_preview}
														/>
													</div>
												</Row>
											</Well>
										</Col>
										<Col sm={12}>
											<FormGroup controlId='repair_result'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'處理結論(記錄用/不顯示於報告)'}</ControlLabel>
												<TextareaWithLink
													disabled={!enableEdit}
													value={repair_result}
													onChange={(event) => this.setState({ repair_result: event.target.value })}
													componentClass='textarea'
													rows={
														repair_result
															? repair_result.split(/[\n]/gm).length > 5
																? repair_result.split(/[\n]/gm).length
																: 5
															: 5
													}
												/>
												{/* <FormControl
													disabled={!enableEdit}
													value={repair_result}
													onChange={(event) => this.setState({ repair_result: event.target.value })}
													componentClass='textarea'
													style={{ height: 100 }} /> */}
											</FormGroup>
										</Col>
										<DropDownMenu
											sm={12}
											label={'結果'}
											clearable={true}
											disabled={!enableEdit}
											stateName='satisfactionId'
											value={satisfactionId}
											valueKey='satisfaction_id'
											labelKey='satisfaction_name'
											onChange={(option) => {
												const value = option ? option.satisfaction_id : '0';

												this.setState({ satisfactionId: value })
											}}
											options={service_result_data}
											filterOptions={this.filterOptions} />
									</Row>
								</Well>
							</Col>

							<Col sm={12}>
								<Row>
									<Col sm={12}>
										<ControlLabel>{'零件更換'}</ControlLabel>
										{
											// 開關零件查詢
											enableEdit ?
												<Button
													onClick={(e) => { this.togglePartsSearchArea('showPartsSearchArea') }}
													style={{
														marginLeft: 5,
														marginBottom: 2,
														padding: '1px 5px',
														display: 'inline-block'
													}}>
													{
														this.state.showPartsSearchArea
															? languageData['441'][languageCode]
															: languageData['283'][languageCode]
													}
												</Button>
												: null
										}
										{
											enableEdit ?
												<div
													className='btn_part add'
													style={{
														right: 15,
														position: 'absolute',
														top: -10
													}}
													onClick={() => this.addPart()}>
													<Tooltip tipText={languageData['461'][languageCode]} />
												</div>
												: null
										}
									</Col>
								</Row>
								{
									this.state.showPartsSearchArea ?
										<Tabs activeKey={activeTabKey} onSelect={this.onTabClick} id='div-repair-tabs-container'>
											<Tab eventKey={1} title={'搜尋編號'}>
												<PartsSearchAreaCt
													onAddToParts={(e) => { this.onAddToParts(e, 0) }}
													onAddToPartsType={'partsList'}
												/>
												<Hr />
											</Tab>
											<Tab eventKey={2} title={'自領貨單'}>
												<PartsSearchAreaCt
													onAddToParts={(e) => { this.onAddToParts(e, 0) }}
													onAddToPartsType={'shippingRecords'}
												/>
												<Hr />
											</Tab>
										</Tabs>
										: null
								}
								<Well style={{ marginBottom: 15 }}>
									<Row>
										<Col sm={12}>
											{
												newParts.length > 0 ?
													newParts.map((item, ind) => {
														return (
															<Row key={ind}>
																<Col sm={4}>
																	<FormGroup controlId={`partId_${ind}`}>
																		<ControlLabel style={{ fontWeight: 'bold' }}>{'產品編號'}</ControlLabel>
																		<FormControl
																			disabled={!enableEdit}
																			type='text'
																			value={item.part_id}
																			style={{ height: 36 }}
																			onChange={(event) => {
																				newParts[ind].part_id = event.target.value;
																				this.setState({ parts: newParts });
																			}}
																		/>
																	</FormGroup>
																</Col>
																<Col sm={4}>
																	<FormGroup controlId={`partName_${ind}`}>
																		<ControlLabel style={{ fontWeight: 'bold' }}>{'品名規格'}</ControlLabel>
																		<FormControl
																			disabled={!enableEdit}
																			type='text'
																			value={item.part_name}
																			style={{ height: 36 }}
																			onChange={(event) => {
																				newParts[ind].part_name = event.target.value;
																				this.setState({ parts: newParts });
																			}}
																		/>
																	</FormGroup>
																</Col>
																<Col sm={4}>
																	<FormGroup controlId={`amount_${ind}`}>
																		<ControlLabel style={{ fontWeight: 'bold' }}>{'數量'}</ControlLabel>
																		<FormControl
																			disabled={!enableEdit}
																			type='text'
																			value={item.amount}
																			style={{ height: 36 }}
																			onChange={(event) => {
																				newParts[ind].amount = event.target.value;
																				this.setState({ parts: newParts });
																			}}
																		/>
																	</FormGroup>
																	{
																		enableEdit ?
																			<div
																				className='btn_part remove'
																				onClick={() => this.removePart(ind)}>
																				<Tooltip tipText={languageData['609'][languageCode]} />
																			</div>
																			: null
																	}
																</Col>
															</Row>
														)
													})
													:
													<Row>
														<Col sm={12}>{'查無資料'}</Col>
													</Row>
											}
										</Col>
									</Row>
								</Well>
							</Col>

							<Col sm={12}>
								<div style={{ marginBottom: 5, fontWeight: 'Bold' }}>{'費用資訊'}</div>
							</Col>
							<Col sm={12}>
								<Well style={{ marginBottom: 15 }}>
									<Row>
										<DropDownMenu
											sm={12}
											label={'收費內容'}
											disabled={!enableEdit}
											stateName='cost_type'
											value={cost_type}
											valueKey='value'
											labelKey='value'
											onChange={(option) => this.setState({ cost_type: option.value })}
											options={_.filter(basic_data, { group_name: 'repair_cost_type' })}
											filterOptions={this.filterOptions} />
										<Col sm={12}>
											<FormGroup controlId='message'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'跨部門聯絡事項'}</ControlLabel>
												<TextareaWithLink
													disabled={!enableEdit}
													value={message}
													onChange={(event) => this.setState({ message: event.target.value })}
													componentClass='textarea'
													rows={
														message
															? message.split(/[\n]/gm).length > 5
																? message.split(/[\n]/gm).length
																: 5
															: 5
													}
												/>
												{/* <FormControl
													disabled={!enableEdit}
													value={message}
													onChange={(event) => this.setState({ message: event.target.value })}
													componentClass='textarea'
													style={{ height: 100 }} /> */}
											</FormGroup>
										</Col>
										<Col sm={12}>
											<FormGroup controlId='remarks'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'備註'}</ControlLabel>
												<TextareaWithLink
													disabled={!enableEdit}
													value={remarks}
													onChange={(event) => this.setState({ remarks: event.target.value })}
													componentClass='textarea'
													rows={
														remarks
															? remarks.split(/[\n]/gm).length > 5
																? remarks.split(/[\n]/gm).length
																: 5
															: 5
													}
												/>
												{/* <FormControl
													disabled={!enableEdit}
													value={remarks}
													onChange={(event) => this.setState({ remarks: event.target.value })}
													componentClass='textarea'
													style={{ height: 100 }} /> */}
											</FormGroup>
										</Col>
										<DayPicker
											showRequiredMark={status === '3' ? true : false}
											labelFontWeight='bold'
											sm={3}
											outerLabel={'結案日期'}
											disabled={!enableEdit}
											onChange={(date) => this.setState({ leave_time: date })}
											dayStateName='leave_time'
											dayValue={leave_time} />
										<Col sm={9}>
											<div style={{ fontWeight: 'Bold', marginBottom: 5 }}>{'顧客簽章'}</div>
											{
												signature_images.length ?
													signature_images.map((x, y) => (
														<a key={y} className='sign_img' href={x.file_name} target='_blank'>
															<img role='img' src={x.thumbnail} alt='' className='text-center' />
														</a>
													))
													:
													<div style={{ height: 50 }} />
											}
										</Col>
									</Row>
								</Well>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div></div>
						<div style={{ justifyContent: 'center' }}>
							{btn_prev_page}
							{btn_next_page}
						</div>
						<div style={{ justifyContent: 'flex-end' }}>
							{btn_save}
							{/* {btnExportPDF}
							{btn_copy} */}
							<Button onClick={closeModal}>{btn_cancel_text}</Button>
						</div>
					</Modal.Footer>
				</Modal>
				{
					showSearchSNResult ?
						<SearchSNResult
							selectSNValue={selectSNValue}
							filterOptions={this.filterOptions}
							serialNumberList={serialNumberList}
							dispatch={this.props.dispatch}
							onSNModalChange={(item) => { this.handlers.onSNModalChange(item) }}
							closeModal={() => { this.handlers.onSearchSNResultClick(0) }}
							onSaveSN={() => { this.handlers.onSearchSNResultClick(1) }}
							propsPackageFromSkyFamily={this.props.propsPackageFromSkyFamily}
							parentStateHandler={this.props.parentStateHandler} />
						: ''
				}
				{
					// 利用&&運算子，前參數true時會傳回後參數，false時會傳回自己
					// div包裝是消除scroll出現導致畫面跳動，position設為relative讓pdf內容的絕對定位歸屬於其下，讓overflow hidden有效
					repairPdfContent && <div style={{ position: 'relative', overflow: 'hidden' }}>{repairPdfContent.map((item, ind) => item)}</div>
				}
				{
					showSearchCompanyContactModal ?
						<SearchCompanyContactResult
							filterOptions={this.filterOptions}
							dispatch={this.props.dispatch}
							state={this.state}
							setSearchData={(stateName, data) => { this.setState({ [stateName]: data }) }}
							onTabClickSearch={(type) => { this.onTabClickSearch(type) }}
							// onSNModalChange={(item) => { this.handlers.onSNModalChange(item) }}
							closeModal={(e) => { this.handlers.onShowSearchCompanyContactModal(0) }}
							onChangeSelectValue={(type, data) => { this.handlers.onSearchCompanyData(type, data) }}
							onSearch={(type, data) => { this.handlers.onSearchCompanyData(type, data) }}
							onSave={(type) => { this.handlers.onSearchCompanyData(type) }}
							propsPackageFromSkyFamily={this.props.propsPackageFromSkyFamily}
							parentStateHandler={this.props.parentStateHandler} />
						: null
				}
			</div>
		);
	}
}





// WEBPACK FOOTER //
// ./src/salesky/routes/online_repair/OnlineRepairServiceCt.jsx